import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addRole } from "@/api/system/role";
import { dealRoleType, dealRoleTypeData, stringToArray } from "@/util/utils";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "selectDefaultPage",
  data: function data() {
    return {
      defaultStaticProps: {
        children: "children",
        label: "name" || "label"
      },
      defaultExpandedKeys: [],
      defaultCheckedArray: [],
      checkedId: "",
      checkedName: "",
      treeKey: Date.parse(new Date())
    };
  },
  components: {},
  computed: _objectSpread(_objectSpread({}, mapGetters(["defaultPageDialog", "userMenus", "roleFormData"])), {}, {
    radioUserMenus: function radioUserMenus() {
      var radioUserMenus = JSON.parse(JSON.stringify(this.userMenus));
      return radioUserMenus;
    }
  }),
  watch: {
    defaultPageDialog: function defaultPageDialog(val) {
      var _this = this;

      this.defaultExpandedKeys = [];

      if (!val) {
        this.checkedId = "";
        this.checkedName = "";
        this.$refs.radioMenuTree.setCheckedKeys([]);
      } else {
        this.treeKey = Date.parse(new Date());
        this.checkedId = this.roleFormData.defaultPageId;
        this.checkedName = this.roleFormData.defaultPageId;
        this.$nextTick(function () {
          _this.radioUserMenus.forEach(function (item, index) {
            if (item.children.length > 0) {
              item.children.forEach(function (value, key) {
                if (value.id == _this.roleFormData.defaultPageId) {
                  _this.defaultExpandedKeys = [].concat([item.id]);
                  return;
                }
              });
            }
          });

          _this.$refs.radioMenuTree.setCheckedKeys([_this.roleFormData.defaultPageId]);
        });
      }
    },
    radioUserMenus: {
      handler: function handler(newVal, oldVal) {
        this.generateStaticTree(newVal);
      },
      immediate: true,
      deep: true
    }
  },
  created: function created() {},
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setDefaultPageDialog: "setDefaultPageDialog",
    setDefaultPage: "setDefaultPage"
  })), {}, {
    handleDialogClose: function handleDialogClose() {
      this.setDefaultPageDialog(false);
    },
    handleStaticNodeClick: function handleStaticNodeClick(data) {// console.log("--静态树点击节点data--", data);
    },
    handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
      if (checked === true) {
        this.checkedId = data.id;
        this.checkedName = data.name;
        this.$refs.radioMenuTree.setCheckedKeys([data.id]);
      } else {
        if (this.checkedId == data.id) {
          this.$refs.radioMenuTree.setCheckedKeys([data.id]);
        }
      }
    },
    generateStaticTree: function generateStaticTree(source) {
      var _this2 = this;

      if (source && source.length > 0) {
        var filterFun = function filterFun(target) {
          target.forEach(function (item) {
            var nodeIsLeaf = item.hasChildren ? true : false;
            item.label = item.name;
            item.expandId = item.id;
            item.isLeaf = nodeIsLeaf;
            item.popoverId = "popover" + item.id;
            item.popoverVisible = false;

            if (item.hasChildren) {
              item.disabled = true;
            }

            if (item.level === 1 && !_this2.defaultExpandedKeys.includes(item.expandId)) {
              _this2.defaultExpandedKeys.push(item.expandId);
            }

            if (item.children && item.children.length > 0) {
              filterFun(item.children);
            }
          });
        };

        filterFun(source);
        this.$nextTick(function () {});
      } else {
        return;
      }
    },
    // 提交表单
    submit: function submit() {
      this.setDefaultPage({
        name: this.checkedName,
        id: this.checkedId
      });
    }
  })
};